import {
    captionClassName,
    listItemClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const ProductDetailsContainer: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(3),

    [theme.screen.min.tablet]: {
        paddingTop: 0,
        marginBottom: pxToRem(64),
    },
});

export const AttributeContainer: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(60),

    [theme.screen.min.tablet]: {
        marginBottom: pxToRem(40),
        marginTop: pxToRem(-2),
    },
});

export const AttributeCaption: StyleRule = ({ theme }) => ({
    paddingBottom: pxToRem(7.5),
    ...theme.siteVariables.textStyles.Heading.Medium65,
    letterSpacing: theme.siteVariables.letterSpacingSmall,
    textTransform: 'uppercase',
    marginBottom: pxToRem(12),
    lineHeight: theme.siteVariables.lineHeightSmallest,

    [theme.screen.min.tablet]: {
        lineHeight: theme.siteVariables.lineHeightDefault,
        marginBottom: pxToRem(2),
        padding: pxArrayToRem([12, 0]),
        borderBottom: `2px solid ${theme.siteVariables.colors.grey[125]}`,
        textTransform: 'none',
        fontSize: pxToRem(22),
        ...theme.siteVariables.textStyles.Text.Roman55,
    },
});

export const ProductDetailsList: StyleRule = ({
    theme: { screen, siteVariables },
}) => ({
    marginTop: pxToRem(-2),
    borderTop: 'none !important',

    [`& .${listItemClassName}`]: {
        display: 'flex',
        alignItems: 'start',
        paddingTop: pxToRem(24),
        flexGrow: 0,
        flexShrink: 1,
        borderBottom: `${pxToRem(1)} solid #d2d2d0`,
        letterSpacing: siteVariables.letterSpacingNormal,
        lineHeight: siteVariables.lineHeightDefault,
        paddingBottom: pxToRem(8),
        minHeight: pxToRem(58),

        [screen.min.tablet]: {
            paddingTop: 'unset',
            alignItems: 'center',
            minHeight: pxToRem(56),
            borderBottom: `2px solid ${siteVariables.colors.grey[125]}`,
            paddingBottom: 'unset',
        },

        [`& > .${captionClassName}`]: {
            display: 'flex',
            alignItems: 'flex-end',

            [screen.min.tablet]: {
                alignItems: 'flex-start',
            },
        },
        [`& ul`]: {
            fontSize: siteVariables.fontSizes.caption03,
            justifyContent: 'center',
        },
    },
});

export const ProductDetailsListItemLabel: StyleRule = ({
    theme: { screen, siteVariables },
}) => ({
    fontSize: `${pxToRem(14)} !important`,
    color: `${siteVariables.colors.charcoal[100]} !important`,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minWidth: pxToRem(185),
    width: pxToRem(185),
    letterSpacing: siteVariables.letterSpacingNormal,
    lineHeight: 1.5,

    [screen.min.tablet]: {
        textAlign: 'start',
        minWidth: pxToRem(247),
        width: '100%',
        fontSize: `${pxToRem(16)} !important`,
        letterSpacing: siteVariables.letterSpacingMedium,
        lineHeight: siteVariables.lineHeightDefault,
    },
});

export const ProductDetailsListItemValue: StyleRule = ({
    theme: { screen, siteVariables },
}) => ({
    color: `${siteVariables.colors.primitive.black} !important`,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    justifyContent: 'end',
    textAlign: 'end',
    listStyle: 'none',
    '& li': {
        margin: 0,
    },

    [screen.min.tablet]: {
        gap: pxToRem(10),
        maxWidth: pxToRem(510),
        justifyContent: 'center',
        paddingBottom: 'unset',
        textAlign: 'start',
        flexGrow: 0,
        '& li': {
            lineHeight: 1,
        },
    },
});

export const AttributeOptions: StyleRule = ({
    theme: { screen, siteVariables },
}) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    textAlign: 'end',
    listStyle: 'none',
    '& li': {
        margin: 0,
        lineHeight: siteVariables.lineHeightDefault,
    },
    paddingInlineStart: 0,
    [screen.min.tablet]: {
        gap: pxToRem(10),
        maxWidth: pxToRem(510),
        padding: pxArrayToRem([13, 0, 13, 0]),
        textAlign: 'start',
        '& li': {
            lineHeight: 1,
        },
    },
});
